
import React from 'react'
import {connect} from "react-redux";

import './resources/css/layout.css';
import "@blueprintjs/core/lib/css/blueprint.css";
import Content from "./Content"
import Login from "./Login";
import {loadDatosMaestros} from "./redux/datosmaestros/actions";
import {getDispositivo, obtenerClinicaCodigo} from "./utils/WindowUtils";
import {estadoChangeClinica} from "./redux/estado/actions";
import AvisoModalControlador from "../framework2/ej2/UI/AvisoModalControlador";
import ConfirmadorControlador from "../framework2/ej2/UI/ConfirmadorControlador";


class Main extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    componentDidMount(){
        const {datosmaestros} = this.props;

        let clinicaCodigo= obtenerClinicaCodigo();
        this.setState({clinicaCodigo: clinicaCodigo});
        this.props.dispatch(loadDatosMaestros(clinicaCodigo));

        this.dispositivo= getDispositivo();
    }



    render() {
        const {clinicaCodigo} = this.state;

        let appHeaderClassName= "App-header_Alaquas";
        if (clinicaCodigo == 2)
            appHeaderClassName= "App-header_Massanassa";

        let widthImagen= 250;
        if (this.dispositivo == 'mobile' || this.dispositivo == 'tablet')
            widthImagen= 125;

        return (
        <div className="App">
            <header className={appHeaderClassName}>
                <div className="App-header-logo">
                    {clinicaCodigo == 1 &&
                    <img src={require('./resources/images/logo_alaquas.png')} width={widthImagen} alt={"logo"}/>
                    }
                    {clinicaCodigo == 2 &&
                        <img src={require('./resources/images/logo_massanassa.png')} width={widthImagen} alt={"logo"}/>
                    }
                </div>
                <div className="App-header-titulo">
                    EJ2 GESTIÓN DENTAL
                </div>
                <div className="App-header-login">
                    <Login />
                </div>
            </header>

            <AvisoModalControlador />
            <ConfirmadorControlador />
            <Content />



        </div>
        );
    }
}


const mapStateToProps = function(state) {
    return {
        configuracion: state.configuracion,
        datosmaestros: state.datosmaestros,
    }
}

export default connect(mapStateToProps)(Main);


